var App = App || {};

App.ImageCarousel = (function ($) {
    'use strict';

    function init() {
        const component = $(".image-carousel");
        var elms = component.find(".image-carousel__container .splide");


        for (var i = 0; i < elms.length; i++) {
            const slider = new Splide(elms[i], {
                cover: true,
                heightRatio: 0.5,
                autoScroll: true,
                type:'loop'
            });
            
            slider.mount();

            lightbox.option({
                'resizeDuration': 200,
                'wrapAround': true,
                'albumLabel': "Image Carousel - use keyboard arrows to navigate, and esc key to close"
            });
        };
    }


    // When a lightbox is opened
    $('[data-lightbox]').on('click', function (e) {
        // Set a timeout to allow the lightbox to fully open
        setTimeout(function () {
            // Find the first focusable element within the lightbox
            var focusableElement = $("#lightbox").find('.lb-nav a').first();

            // Focus on the element
            if (focusableElement.length) {
                focusableElement.focus();
            }
        }, 100); // Adjust timeout as needed
    });

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.ImageCarousel.init();
});